"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _wsRail = _interopRequireDefault(require("./wsRail"));
var _state = require("printableWorksheets/state");
var _AppMediaProvider = require("../../../baseStyles/AppMediaProvider");
var _printableWorksheets = require("printableWorksheets");
var _AllWorksheetsScreen = _interopRequireDefault(require("../views/AllWorksheetsScreen"));
require("./styles.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var WSList = function WSList() {
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    _usePrintableWorkshee2 = _usePrintableWorkshee.viewData,
    viewData = _usePrintableWorkshee2 === void 0 ? [] : _usePrintableWorkshee2,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment,
    activeBreadcrumb = _usePrintableWorkshee.activeBreadcrumb,
    activeNode = _usePrintableWorkshee.activeNode,
    activeGrade = _usePrintableWorkshee.activeGrade;
  var _useAppMediaProvider = (0, _AppMediaProvider.useAppMediaProvider)(),
    currentDevice = _useAppMediaProvider.currentDevice;
  var isLastTopic = (0, _react.useMemo)(function () {
    if (activeBreadcrumb.length > 0) {
      var _lastChild$children;
      var lastChild = activeBreadcrumb[activeBreadcrumb.length - 1];
      if ((lastChild === null || lastChild === void 0 || (_lastChild$children = lastChild.children) === null || _lastChild$children === void 0 ? void 0 : _lastChild$children.length) === 0) {
        return true;
      }
    }
    return false;
  }, [activeBreadcrumb, viewData]);
  var sliceWorksheetsLength = (0, _react.useMemo)(function () {
    // Klass container is always of width 960px i.e., close to tablet screen.
    if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      return 16;
    }
    switch (currentDevice) {
      case _AppMediaProvider.DeviceTypes.Desktop:
        return 4;
      case _AppMediaProvider.DeviceTypes.Tablet:
        return 3;
      default:
        return 10;
    }
  }, [viewData, currentDevice]);
  (0, _react.useEffect)(function () {
    var div = document.getElementById('printables-scrollable-div');
    if (div && div.scrollTop !== 0) {
      div.scrollTop = 0;
    }
  }, [viewData, activeBreadcrumb]);
  var renderRails = function renderRails() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, viewData === null || viewData === void 0 ? void 0 : viewData.map(function (item, index) {
      var _item$worksheets, _item$worksheets2;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: item.title + index
      }, /*#__PURE__*/_react["default"].createElement(_wsRail["default"], {
        title: item.title,
        worksheets: ((_item$worksheets = item.worksheets) === null || _item$worksheets === void 0 ? void 0 : _item$worksheets.length) > sliceWorksheetsLength ? (_item$worksheets2 = item.worksheets) === null || _item$worksheets2 === void 0 ? void 0 : _item$worksheets2.slice(0, sliceWorksheetsLength) : item.worksheets,
        playblesCount: item.playblesCount,
        nodeId: item.nodeId,
        item: item
      }));
    }), activeGrade && activeNode !== null && activeNode !== void 0 && activeNode.id ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "all-ws"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "all-ws__title"
    }, "All ".concat(activeNode === null || activeNode === void 0 ? void 0 : activeNode.title, " worksheets for ").concat(_state.GradeToStringMapping[activeGrade])), /*#__PURE__*/_react["default"].createElement("div", {
      className: "all-ws__list"
    }, /*#__PURE__*/_react["default"].createElement(_AllWorksheetsScreen["default"], {
      nodeId: activeNode === null || activeNode === void 0 ? void 0 : activeNode.id,
      dontShowLoader: true
    }))) : null);
  };
  var renderList = function renderList() {
    var _activeBreadcrumb;
    return /*#__PURE__*/_react["default"].createElement(_AllWorksheetsScreen["default"], {
      nodeId: (_activeBreadcrumb = activeBreadcrumb[activeBreadcrumb.length - 1]) === null || _activeBreadcrumb === void 0 ? void 0 : _activeBreadcrumb.id,
      "data-sentry-element": "AllWorksheetsScreen",
      "data-sentry-component": "renderList",
      "data-sentry-source-file": "wsList.tsx"
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ws-rails-container".concat(currentDevice == _AppMediaProvider.DeviceTypes.Mobile ? ' mobile-view' : ''),
    "data-sentry-component": "WSList",
    "data-sentry-source-file": "wsList.tsx"
  }, isLastTopic ? renderList() : renderRails());
};
var _default = exports["default"] = WSList;